import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const GetList = createAsyncThunk(
  "GetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.INDUSTRYGETLIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

const initialState = {
  GetListData: {
    data: null,
    error: null,
  },
};

const IndustrySlice = createSlice({
  name: "INDUSTRYSLICE",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetList.fulfilled, (state, action) => {
        state.GetListData.data = action.payload;
      })
      .addCase(GetList.rejected, (state, action) => {
        state.GetListData.error = action.error.message;
      });
  },
});

export default IndustrySlice.reducer;
